<div>
  <div odxLayout="flex gap-small" class="odx-padding-bottom-8">
    <h6 class="odx-title-6" i18n="@@groupMenu.createdGroup.header">{{ group.name }}</h6>
    <app-group-number-chip [group]="group"></app-group-number-chip>
  </div>
  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      variant="primary"
      (click)="editGroup(group)"
      [odxTooltip]="tooltipTextEditGroup"
      [odxTooltipOptions]="{ position: 'bottom' }"
    >
      <odx-icon name="edit" class="exhaust-air" size="medium"></odx-icon>
    </button>
    <button
      odxButton
      variant="secondary"
      (click)="deleteGroup()"
      [odxTooltip]="tooltipTextDeleteGroup"
      [odxTooltipOptions]="{ position: 'bottom' }"
    >
      <odx-icon name="delete" class="exhaust-air" size="medium"></odx-icon>
    </button>
    <app-toggle-group-visibility-button
      class="visibility-switch"
      [group]="group"
      [isSelected]="this.isSelected"
    ></app-toggle-group-visibility-button>
  </app-floorplan-menu-item-buttons>
</div>
